import { render } from "./Selectempresa.vue?vue&type=template&id=5180b186&scoped=true"
import script from "./Selectempresa.vue?vue&type=script&lang=js"
export * from "./Selectempresa.vue?vue&type=script&lang=js"

import "./Selectempresa.vue?vue&type=style&index=0&id=5180b186&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5180b186"]])

export default __exports__